import { hasDevicePermission } from './devicePermissionUtils';

export const getDeviceIndexMap = (connectedDevices = []) => {
  const map = new Map();
  connectedDevices.forEach((device, index) => {
    map.set(device.id, index + 1);
  });
  return map;
};

// Filter device types based on view permissions
export const getFilteredDeviceTypes = (systemType, deviceTypeMap, perms) => {
  // Ensure the context provides the device type map
  if (!deviceTypeMap) return {};

  let deviceTypesForSystem = [];

  // Handle an array shape: [{ system_type, device_type }, ...]
  if (Array.isArray(deviceTypeMap)) {
    deviceTypesForSystem = deviceTypeMap
      .filter((entry) => entry?.system_type === systemType)
      .map((entry) => entry?.device_type)
      .filter(Boolean);
  } else if (typeof deviceTypeMap === 'object' && deviceTypeMap !== null) {
    // Handle shape where deviceTypeMap[systemType] === ['typeA', 'typeB']
    if (Array.isArray(deviceTypeMap[systemType])) {
      deviceTypesForSystem = deviceTypeMap[systemType];
    } else {
      // Handle shape where deviceTypeMap is { deviceType: { system_type: 'X', ... }, ... }
      deviceTypesForSystem = Object.keys(deviceTypeMap || {}).filter((deviceType) => {
        const info = deviceTypeMap[deviceType];
        return info && info.system_type === systemType;
      });
    }
  }

  if (!deviceTypesForSystem || deviceTypesForSystem.length === 0) return {};

  // Filter out device types the user can't view and return an object of { deviceType: deviceType }
  const filteredDeviceTypes = {};
  deviceTypesForSystem.forEach((deviceType) => {
    if (hasDevicePermission(perms, systemType, deviceType, 'view')) {
      filteredDeviceTypes[deviceType] = deviceType;
    }
  });
  return filteredDeviceTypes;
};

export const getfilteredConnectedDevices = (connectedDevices, deviceSearchFilter, deviceType) => {
  const filteredConnectedDevices = connectedDevices?.filter(
    (device) => device.device_type.includes(deviceType) && deviceSearchFilter(device),
  );
  return filteredConnectedDevices || [];
};
